import React from "react";
import { Droplets, ShieldCheck, Leaf, Clock } from "lucide-react";

const PILLARS = [
  {
    icon: Droplets,
    title: "Soft-Wash Certified",
    desc: "We use low-pressure detergent systems for delicate surfaces — never blasting shingles or blowing out mortar.",
  },
  {
    icon: ShieldCheck,
    title: "Licensed & Insured",
    desc: "Fully bonded, insured and background-checked crews. Your property is protected, always.",
  },
  {
    icon: Leaf,
    title: "Pet & Plant Safe",
    desc: "Biodegradable detergents. We pre-water landscaping and rinse everything thoroughly after each job.",
  },
  {
    icon: Clock,
    title: "On-Time, Every Time",
    desc: "Same-day quotes, next-week booking, and a live text update when we're on the way.",
  },
];

export default function WhyUs() {
  return (
    <section
      className="relative py-24 md:py-32 bg-black overflow-hidden"
      data-testid="why-section"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="max-w-3xl mb-14">
          <div className="text-xs uppercase tracking-[0.3em] font-bold text-[#C4FF00] mb-4">
            — Why Spotless
          </div>
          <h2 className="font-display text-4xl md:text-6xl uppercase tracking-tighter text-white leading-[0.95]">
            The way it should
            <br />
            <span className="text-[#00BFFF]">have been done.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {PILLARS.map((p, i) => {
            const Icon = p.icon;
            return (
              <div
                key={p.title}
                className="relative rounded-2xl border border-zinc-800 bg-[#0A0A0A] p-7 hover:border-[#C4FF00]/50 transition-colors"
                data-testid={`why-pillar-${i}`}
              >
                <div className="h-12 w-12 rounded-xl border border-zinc-800 bg-black grid place-items-center text-[#C4FF00]">
                  <Icon className="h-6 w-6" />
                </div>
                <h3 className="mt-5 font-display text-xl uppercase tracking-tight text-white">
                  {p.title}
                </h3>
                <p className="mt-2 text-sm text-zinc-400 leading-relaxed">
                  {p.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
